<template>
    <div class="form_wrap">
        <div class="form_box ragister">
            <div class="form_inner">
                <h2>{{ form.w === 'u' ? '정보수정' : '회원가입' }}</h2>
                <form action="" method="post" class="">
                    <input type="hidden" name="w" id="w" v-model="form.w">
                    <input type="hidden" name="user_id" id="user_id" v-model="form.user_id">
                    <div class="inp_flx">
                        <div class="row">
                            <div class="inp">
                                <label for="username">아이디 <span class="red_f">*</span></label>
                                <input type="text" name="username" id="username" v-model="form.username" placeholder="아이디를 입력해주세요" :disabled="form.w === 'u'" >
                            </div>
                            <div class="inp">
                                <label for="name">이름 <span class="red_f">*</span></label>
                                <input type="text" name="name" id="name" v-model="form.name" placeholder="이름을 입력해주세요">
                            </div>
                        </div>
                        <div class="row">
                            <div class="inp">
                                <label for="user_pw">비밀번호 <span class="red_f" v-if="form.w !== 'u'">*</span></label>
                                <input type="password" name="user_pw" id="user_pw" v-model="form.user_pw" placeholder="비밀번호를 입력해주세요">
                            </div>
                            <div class="inp">
                                <label for="user_pw_re">비밀번호 확인 <span class="red_f" v-if="form.w !== 'u'">*</span></label>
                                <input type="password" name="user_pw_re" id="user_pw_re" v-model="form.user_pw_re" placeholder="비밀번호를 다시 입력해주세요">
                            </div>
                        </div>
                        <div class="row">
                            <div class="inp">
                                <label for="hp">전화번호 <span class="red_f">*</span></label>
                                <input type="text" name="hp" id="hp" v-model="form.hp" @input="onlyNumber" placeholder="전화번호를 입력해주세요">
                            </div>
                            <div class="inp">
                                <label for="email">이메일 <span class="red_f">*</span></label>
                                <input type="text" name="email" id="email" v-model="form.email" placeholder="이메일을 입력해주세요">
                            </div>
                        </div>
                        <div class="row">
                            <div class="inp">
                                <label for="company">회사/또는 소속기관</label>
                                <input type="text" name="company" id="company" v-model="form.company" placeholder="ex) 삼성전자">
                            </div>
                            <div class="inp">
                                <label for="level">직책/또는 직위</label>
                                <input type="text" name="level" id="level" v-model="form.level" placeholder="ex) 본부장">
                            </div>
                        </div>
                        <div class="inp">
                            <label for="platform">플랫폼 가입 목적</label>
                            <div class="input_box">
                                <select name="platform" id="platform">
                                    <option value="1">플랫폼 이용</option>
                                </select>
                            </div>
                        </div>
                        <div class="inp">
                            <label for="user_grade">명함(혹은 소속을 증명할 수 있는 자료)첨부</label>
                            <div class="up_area"
                                @dragover.prevent
                                @drop.prevent="handleDrop"
                                @click="openFile"
                                >
                                <img src="/img/imgfile.4c74f9bc.svg" alt="">
                                <span v-if="!preview">이미지를 드래그해서 드롭해주세요.</span>
                                <img v-if="preview" :src="preview" class="preview-img" />
                            </div>
                        </div>

                        <div class="file">
                        </div>

                        <input type="file" name="namecard" id="namecard" ref="namecard" style="display:none;" accept="image/jpeg, image/png, image/jpg" @change="handleFileSelect">
                    </div>
                    
                    <div class="btn">
                        <button class="buttn" type="button" @click="form.w === 'u' ? modifyForm() : submitForm()">{{ form.w === 'u' ? '수정하기' : '회원가입하기' }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'RegisterForm',

    data() {
        return {
            preview: null,  // 미리보기 이미지 URL

        form: {
                w: "",
                user_id: "",
                username: "",
                name: "",
                user_pw: "",
                user_pw_re: "",
                hp: "",
                email: "",
                company: "",
                level: "",
                platform: "1"
            }
        };
    },
    mounted() {
        this.checkLoginStatus();
    },

    methods: {
        async checkLoginStatus() {
            try {
                const res = await api.get("/admin/user-info", { withCredentials: true });
    
                if (res.data.loggedIn) {
                    // 로그인 상태
                    this.form.w = "u";
console.log( res.data.user );
                    // 사용자 정보 화면에 채우기
                    this.form.user_id = res.data.user.id;
                    this.form.username = res.data.user.username;
                    this.form.name = res.data.user.name;
                    this.form.hp = res.data.user.hp;
                    this.form.email = res.data.user.email;
                    this.form.company = res.data.user.company;
                    this.form.level = res.data.user.grade;
                    this.form.platform = res.data.user.platform ?? "1";

                    // 명함 이미지 미리보기
                    if (res.data.user.namecard_path) {
                        const base = api.defaults.baseURL.replace(/\/$/, '')    
                        this.preview = `${base}/${res.data.user.namecard_path.replace(/^\//, '')}`
                    }

                    
                }
            } catch (e) {
                console.log("로그인 아님");
            }
        },

    async modifyForm() {
        try {
            // 기본 검증 생략하려면 아래 주석 제거
            // if (!this.form.name) return alert("이름을 입력해주세요.");
            const pw = this.form.user_pw;
            const pwRe = this.form.user_pw_re;

            // 둘 중 하나라도 입력된 경우
            if (pw || pwRe) {
                if (!pw || !pwRe) {
                    alert("비밀번호와 비밀번호 확인을 모두 입력해주세요.");
                    return;
                }

                if (pw !== pwRe) {
                    alert("비밀번호와 비밀번호 확인이 일치하지 않습니다.");
                    return;
                }

                // 선택사항: 비밀번호 규칙도 함께 체크하고 싶다면
                if (!this.isPasswordValid(pw)) {
                    alert("비밀번호는 대문자/소문자/숫자/특수문자 포함 8자 이상이어야 합니다.");
                    return;
                }
            }    

            let formData = new FormData();
            for (let key in this.form) {
                formData.append(key, this.form[key]);
            }

            // 명함이 새로 업로드되었을 때만 전송
            if (this.$refs.namecard.files[0]) {
                formData.append("namecard", this.$refs.namecard.files[0]);
            }

            await api.get('/sanctum/csrf-cookie', { withCredentials: true });

            const response = await api.post(
                '/admin/update-user',
                formData,
                { withCredentials: true }
            );

            if (response.data.success) {
                alert("회원 정보가 성공적으로 수정되었습니다.");
                window.location.reload();
            } else {
                alert(response.data.message || "수정 중 오류 발생");
            }

        } catch (e) {
            console.error(e);
            alert("서버 오류가 발생했습니다.");
        }
    },
    
        getCookie(name) {
            const matches = document.cookie.match(
                new RegExp("(?:^|; )" + name.replace(/[$()*[\]\\/+?.^]/g, '\\$&') + "=([^;]*)")
            );
            return matches ? matches[1] : undefined;
        },
        openFile() {
            this.$refs.namecard.click();
        },

        handleFileSelect(e) {
            const file = e.target.files[0];
            this.validateAndPreview(file);
        },

        handleDrop(e) {
            const file = e.dataTransfer.files[0];
            this.validateAndPreview(file);
        },

        validateAndPreview(file) {
            if (!file) return;

            // 허용 확장자 체크
            const allowed = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowed.includes(file.type)) {
                alert('이미지 파일(jpg, jpeg, png)만 업로드 가능합니다.');
                return;
            }

            // 파일을 namecard input에 직접 넣기
            const dt = new DataTransfer();    
            dt.items.add(file);
            this.$refs.namecard.files = dt.files;

            // 미리보기 생성
            this.preview = URL.createObjectURL(file);
        },

        /* 전화번호 숫자만 */
        onlyNumber() {
            this.form.hp = this.form.hp.replace(/[^0-9]/g, "");
        },

        /* 이메일 검증 */
        isEmailValid(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
        },
    /* 아이디: 영문/숫자/_ , 4자 이상 */
        isUsernameValid(username) {
            const regex = /^[A-Za-z0-9_]{4,}$/;
            return regex.test(username);
       },

        /* 이름: 한글 또는 영문만 */
        isNameValid(name) {
            const regex = /^[A-Za-z가-힣]+$/;
            return regex.test(name);
        },

        /* 비밀번호 검증 */
        isPasswordValid(pw) {
            const regex =
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={};:'",.<>/?\\|`~]).{8,}$/;
            return regex.test(pw);
        },

        /* 최종 제출 */
        async submitForm() {
            // 필수값 검증
            if (!this.form.username) return alert("아이디를 입력해주세요.");
            if (!this.isUsernameValid(this.form.username))
                return alert("아이디는 영문, 숫자, _만 가능하며 최소 4자 이상이어야 합니다.");

            // 이름 검증
            if (!this.form.name) return alert("이름을 입력해주세요.");
            if (!this.isNameValid(this.form.name))
                return alert("이름은 한글 또는 영문만 입력 가능합니다.");

            // 비밀번호 검증
            if (!this.form.user_pw) return alert("비밀번호를 입력해주세요.");
            if (!this.isPasswordValid(this.form.user_pw))
            return alert("비밀번호는 대문자/소문자/숫자/특수문자 포함 8자 이상이어야 합니다.");
            if (!this.form.user_pw_re) return alert("비밀번호 확인을 입력해주세요.");
            if (this.form.user_pw !== this.form.user_pw_re)
                return alert("비밀번호와 비밀번호 확인이 일치하지 않습니다.");

            if (!this.form.hp) return alert("전화번호를 입력해주세요.");
            if (!this.form.email) return alert("이메일을 입력해주세요.");

            if (!this.isEmailValid(this.form.email))
                return alert("올바른 이메일 형식이 아닙니다.");

            //if (this.$refs.namecard.files.length === 0)
                //return alert("명함 이미지를 첨부해주세요.");

            // Laravel로 보낼 FormData 생성
            let formData = new FormData();
            for (let key in this.form) {
                formData.append(key, this.form[key]);
            }
            formData.append("namecard", this.$refs.namecard.files[0]);

            try {
                await api.get('/sanctum/csrf-cookie', { withCredentials: true });
                const token = this.getCookie('XSRF-TOKEN');console.log( "token:"+token );

                const registerResponse = await api.post('/admin/register', formData, {withCredentials: true});

                const result = registerResponse.data;

                if (result.success) {
                    alert("회원가입이 완료되었습니다!");
                    window.location.href = "/";
                } else {
                    alert(result.message || "오류가 발생했습니다.");
                }

            } catch (e) {
                console.error(e);
                alert("서버 오류가 발생했습니다.");
            }
        }
    }    
}
</script>